<div id="enrollmentHeader">
    <div class="container">
        <div class="row">
            <div class="col-12 d-flex justify-content-between py-2">
                <div class="logo">
                    <img src="assets/logos/educere_209x90.jpg" alt="">
                </div>

                <div class="cart d-flex align-items-center p-2" *ngIf="showShoppingCart">
                    <span (click)="openShoppingCart()">
                        <span><i class="fas fa-shopping-cart"></i> </span>
                        <span class="cart-count">({{shoppingCart.size}})</span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>